import { render, staticRenderFns } from "./vehiclesList.vue?vue&type=template&id=641c5f2e&scoped=true"
import script from "./vehiclesList.vue?vue&type=script&lang=js"
export * from "./vehiclesList.vue?vue&type=script&lang=js"
import style0 from "./vehiclesList.vue?vue&type=style&index=0&id=641c5f2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641c5f2e",
  null
  
)

export default component.exports